import React, { useEffect, useState } from "react";
import "./Overlapping.css";
import heroImage from "../asset/Boy.png";
import { Link } from "react-router-dom";

const HeroSection = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    // Trigger animation on component mount
    setAnimate(true);
  }, []);

  return (
    <div className="hero-container">
      <div className={`hero-left ${animate ? "animate-left" : ""}`}>
        <h3>
          Apply To <span className="orange">World’S Leading</span>
        </h3>
        <h3>
          <span className="bold">Universities Through Us</span>
        </h3>
        <h1 className="highlight">100% FREE</h1>
        <Link to="/contact" className="cta-button">GET IN TOUCH</Link>
      </div>

      <div className={`hero-right ${animate ? "animate-left" : ""}`}>
        <img src={heroImage} alt="Hero Section" className="hero-image" />
      </div>
    </div>
  );
};

export default HeroSection;
